import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link, useLocation } from "react-router-dom";

import Text from "../styleguide/Text";
import { getFirstLetterUpperCase } from "../utils/parsers";

import { initialMainRoute } from "./routesConstants";
import BreadcrumbBackButton, { isMainPagePath } from "./BreadcrumbBackButton";

function BreadcrumbsComponent() {
  const currentPath = useLocation().pathname;

  if (isMainPagePath(currentPath)) return null;

  const currentPathArray = currentPath.split("/");

  const currentArrayPathWithoutFirst = currentPathArray.slice(1);

  const addInitialRoute = !currentPathArray.includes(initialMainRoute)
    ? [initialMainRoute, ...currentArrayPathWithoutFirst]
    : [];

  const pathFinalArray = addInitialRoute;

  if (pathFinalArray.length === 0) return null;

  return (
    <div className="flex min-h-[64px] items-center gap-3 bg-white px-7 py-2">
      <BreadcrumbBackButton />
      <Breadcrumbs
        className="min-w-0 flex-1"
        maxItems={5}
        aria-label="breadcrumb">
        {pathFinalArray.map((path, idx, paths) => {
          const indexOfCurrentPath = paths.indexOf(path);
          const withoutCurrentPath = paths.slice(1, indexOfCurrentPath + 1);
          const constructedPath = withoutCurrentPath.join("/");

          if (paths.length - 1 === idx) {
            return (
              <Text key={`${path}-${idx}`} className="text-black">
                {getFirstLetterUpperCase(path)}
              </Text>
            );
          }

          return (
            <Link
              key={`${path}-${idx}`}
              to={constructedPath}
              className="text-muted transition-colors hover:text-action">
              {getFirstLetterUpperCase(path)}
            </Link>
          );
        })}
      </Breadcrumbs>
    </div>
  );
}

export default BreadcrumbsComponent;
